import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Rape has never been so beautiful",
  "description": "",
  "published": "2009-12-31T00:00:00.000Z",
  "redirect_from": ["/blog/rape-has-never-been-so-beautiful/swizec/1040"],
  "categories": "Around the World, Clockwork Orange, food for thought, intrigues, Kids and Teens, life, New Year's Eve, People and Society, review, Theatre, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://cm.mladinsko.com/pictures/360/up1607.jpg.jpeg",
        "alt": null
      }}></img>{`Since it's new year's eve day party thingy mcthing I'll keep this short because nobody is going to read it anyway.`}</p>
    <p>{`Last night I went to see A Clockwork Orange at the playhouse and it was just a thing of joy. Shit was so cash.`}</p>
    <p>{`No seriously, everybody who has ever even thought about doing far out things that bend the mind and touch you deeply and truly. I don't think I've ever been this affected by a theatre performance before. It was weird. It was strange. It was fucking brilliant.`}</p>
    <p>{`Such perfect captivation of the story, so amazingly performed. Half the time I was afraid they might actually start pounding away at the audience and doing all manner of strange things to us. And half the mind I was just left with a giant WTFLOL in my head. And then there were times when it was so mindboggling, so sick, so perverted it was painful to watch.`}</p>
    <p>{`If you can possibly find the time, if you can spare the few euro it takes, fucking go see this show. You shan't regret it; hat's off to `}<a parentName="p" {...{
        "href": "http://www.mladinsko.com/"
      }}>{`Mladinsko Gledalisce`}</a>{`.`}</p>
    <p>{`Now if you'll excuse me, I'm feeling a deep urge to go fuck somebody up with a stick.`}</p>
    <p><img parentName="p" {...{
        "src": "https://cm.mladinsko.com/pictures/360/up1635.jpg.jpeg",
        "alt": null
      }}></img><img parentName="p" {...{
        "src": "https://cm.mladinsko.com/pictures/360/up1626.jpg.jpeg",
        "alt": null
      }}></img><img parentName="p" {...{
        "src": "https://cm.mladinsko.com/pictures/360/up1623.jpg.jpeg",
        "alt": null
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/8e807611-944f-4747-8976-d331bf1c5a0d/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=8e807611-944f-4747-8976-d331bf1c5a0d",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      